import { useLastTradepriceOrUndefined } from '../../../hooks/useFeedQuote';

export const useLastPrice = (symbol: string) => {
  return useLastTradepriceOrUndefined(symbol);
};
